import OrderTable from "components/orders-table/OrderTable"

const OrdersPage = () => {
  return (
    <div className="orders-page">
      <OrderTable />
    </div>
  )
}

export default OrdersPage
